import React, { useEffect } from 'react';
import './GoogleTranslate.css';

const GoogleTranslate = () => {
    // State to manage the button text (opposite of current language)
    const [buttonText, setButtonText] = React.useState('Hindi');

    useEffect(() => {
        // Simple cookie reader to set initial state
        const getCookie = (name) => {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        };

        const checkCookie = () => {
            let cookie = getCookie('googtrans');

            // Default to Hindi if no cookie exists (First time visitor)
            if (!cookie) {
                document.cookie = "googtrans=/en/hi; path=/";
                cookie = '/en/hi';
            }

            // If cookie contains '/en/hi', current is Hindi, so show 'English'
            if (cookie && cookie.includes('/en/hi')) {
                setButtonText('English');
            } else {
                setButtonText('Hindi');
            }
        };

        // Check immediately
        checkCookie();

        // Inject custom styles to hide the top bar aggressively
        const style = document.createElement('style');
        style.innerHTML = `
            iframe.goog-te-banner-frame { display: none !important; }
            .goog-te-banner-frame { display: none !important; }
            .VIpgJd-ZVi9od-ORHb { display: none !important; }
            .VIpgJd-ZVi9od-ORHb-OEVmcd { display: none !important; }
            .goog-te-menu-frame { display: none !important; }
            .goog-te-gadget { display: block !important; } /* Restore visibility for the hidden combo */
            body { top: 0px !important; }
            #goog-gt-tt, #goog-gt-tt:hover, .VIpgJd-yTechs-L933Dh, .VIpgJd-yTechs-L933Dh-bzoAcb, .VIpgJd-yTechs-L933Dh-P3pHub, .goog-te-balloon-frame { display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; }
            html body font.goog-text-highlight, html body .goog-text-highlight, font.goog-text-highlight, .goog-text-highlight { background: transparent !important; background-color: transparent !important; box-shadow: none !important; text-shadow: none !important; border: none !important; }
        `;
        document.head.appendChild(style);

        // Check if script is already added
        if (!document.querySelector('script[src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]')) {
            // Define the global callback function
            window.googleTranslateElementInit = () => {
                if (window.google && window.google.translate) {
                    new window.google.translate.TranslateElement(
                        {
                            pageLanguage: 'en',
                            includedLanguages: 'hi,en',
                            // REMOVED 'layout' property to get the default View which includes the Select Combo
                            autoDisplay: false,
                        },
                        'google_translate_element'
                    );
                }
            };

            // Create and append the script
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
            script.async = true;
            document.body.appendChild(script);
        }

        // MutationObserver to fix the body top offset if Google tries to add it
        const observer = new MutationObserver((mutations) => {
            // 1. Maintain body styles
            const bodyStyle = document.body.style;
            if (bodyStyle.top !== '0px' || bodyStyle.position === 'relative' || bodyStyle.minHeight) {
                bodyStyle.top = '0px';
                bodyStyle.position = 'static';
                bodyStyle.minHeight = '';
            }

            // 2. Aggressively hide known banner elements
            const classesToHide = [
                '.goog-te-banner-frame',
                '.VIpgJd-ZVi9od-ORHb',
                '.VIpgJd-ZVi9od-ORHb-OEVmcd'
            ];

            classesToHide.forEach(className => {
                const elements = document.querySelectorAll(className);
                elements.forEach(el => {
                    // Only hide if it's the banner iframe or known banner div
                    if ((el.tagName === 'IFRAME' && !el.classList.contains('goog-te-menu-frame')) ||
                        el.classList.contains('VIpgJd-ZVi9od-ORHb') ||
                        el.classList.contains('VIpgJd-ZVi9od-ORHb-OEVmcd')) {

                        if (el.style.display !== 'none') {
                            el.style.display = 'none';
                        }
                    }
                });
            });
        });

        observer.observe(document.body, { attributes: true, childList: true, subtree: false });

        return () => {
            observer.disconnect();
            if (document.head.contains(style)) {
                document.head.removeChild(style);
            }
        };
    }, []);

    const handleLanguageToggle = () => {
        // Find the Google Translate hidden combo box
        const combo = document.querySelector('.goog-te-combo');
        if (combo) {
            // Check current value directly from the combo box to decide next state
            // If current is empty or 'en', we want to go 'hi'
            // If current is 'hi', we want to go 'en'

            // Note: combo.value might be empty initially for English
            const currentVal = combo.value;

            if (currentVal === 'hi') {
                combo.value = 'en';
                setButtonText('Hindi');
            } else {
                combo.value = 'hi';
                setButtonText('English');
            }

            combo.dispatchEvent(new Event('change'));
        } else {
            console.error('Google Translate combo box not found');
        }
    };

    return (
        <div className="flex items-center">
            {/* Custom clickable text - ADDED 'notranslate' class to prevent the button itself from being translated */}
            <span
                onClick={handleLanguageToggle}
                className="cursor-pointer text-white hover:text-gray-200 font-medium select-none notranslate"
                style={{ fontSize: '14px' }}
            >
                {buttonText}
            </span>

            {/* Hidden Container for the actual Google Widget */}
            {/* We use opacity 0 and absolute positioning to "hide" it while keeping it technically visible for the script to work */}
            <div id="google_translate_element" style={{
                position: 'absolute',
                top: '-9999px',
                left: '-9999px',
                visibility: 'hidden',
                width: '1px',
                height: '1px',
                overflow: 'hidden'
            }}></div>
        </div>
    );
};

export default GoogleTranslate;
